import React from 'react'

const defaultValue = {
  handleSave: null,
  handleSaveAndClose: null,
  handleDelete: null,
  handleClose: null,
  buttonsConfig: {},
  remote: {}
}

/**
 *
 * @type {React.Context<{handleSave: any, handleSaveAndClose: any, handleClose: function | null, handleDelete: function | null, remote: any, buttonsConfig: any }>}
 */
export const PageContext = React.createContext(defaultValue)
